<template>
	<div class="dashboard-layout">

		<main-header></main-header>

		<div class="dashboard-layout-view">
			<router-view />
		</div>

	</div>
</template>

<script>
import MainHeader from '@/components/layouts/includes/MainHeader'

export default {
	components: {
		MainHeader
	},
	data() {
		return {
			message: 'Dashboard'
		}
	}
}
</script>

<style lang="scss">
.dashboard-layout {
	display: flex;
	flex-direction: column;
	height: 100%;

	&-view {
		margin-top: 2rem;
		flex: 1;
	}
}

table {
	font-size: 0.9rem;
}
</style>



// WEBPACK FOOTER //
// DashboardLayout.vue?65c8695e